// src/services/claimService.js
import { apiClient } from "../utils/apiClient";
import { API } from "../utils/apiUrls";

export const getClaimReasons = async () => {
  const url = API.getClaimReasons();
  const resp = await apiClient.get(url);
  return resp.data;
};

export const deleteClaim = async (claimId, merchantId) => {
  if (!claimId) throw new Error("claimId is required to delete claim");

  const url = API.deleteClaim(claimId);
  const resp = await apiClient.delete(url, { params: { merchantId } });
  return resp.data;
};

